module.exports = __webpack_public_path__ + "img/user.9d577869.svg";